const settings = window.appSettings || {};

// Pull networks to attempt image proxy, e.g. "twitter,instagram"
const proxyNetworks = (settings && settings.attemptProxy || '')
  .split(',')
  .filter((networkStr) => networkStr && networkStr.length);

export { settings, proxyNetworks };
